import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import EvalJsonDialog from "../EvalJsonDialog";


const initailEvknData: any = {
  idx : -1,
  task_id: "",
  document_id: "",
  source_title: "",
  difficulty: "",
  question_text: "",
  question_type: "",
  gold_answer: "",
  // answer_index: "",
  cot_rationale: "",
  // options: "",
  created_at: "",
  nia70: "",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const LFSumPage = (props: any) => {

  const [pageType, setPageType] = useState("new")

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [search_doc_id, setSearch_doc_id] = useState("")

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [lfsumQAList, setLfsumQAList] = useState([]);

  const [idx, setIdx] = useState('');
  const [job_yn, setJob_yn] = useState('모두');
  const [gub_cd, setGub_cd] = useState('모두');


  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)


  const updateColEvknData = async (gub: any) => {

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("gub", gub);

    const updatedColEvknData = {
      ...lfsumQAData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      // options: Array.isArray(options) ? options : (() => {
      //   try { return JSON.parse(options as string); } catch { return []; }
      // })(),
    };

    // console.log('바꾼거',JSON.stringify(updatedColEvknData))
    return;
    
    formData.append("lfsumQAData", JSON.stringify(updatedColEvknData));

    await api.post("/updateColEvknData",formData)
    .then((res:any) => {alert(updatedColEvknData.document_id + " 데이터 검수 완료"); setPageType("update"); setBackdrop(false); getLFSumQAList();})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const [lfsumQAData, setLfsumQAData] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  // const [options, setOptions] = useState<any>([]);

  // const options_change = (idx: number, val: string) => {
  //   setOptions((prev:any) => {
  //     const next = [...prev];
  //     next[idx] = val;
  //     return next;
  //   });
  // };

  const handleAdd = () => setReason_path((prev) => [...prev, ""]);
  const handleRemove = (idx: number) =>
    setReason_path((prev) => prev.filter((_, i) => i !== idx));

  
  const search_data = useCallback(async () => {
      api.get('/getColEvknData', {params:{email:email,idx:search_doc_id}})
      .then((res:any) => {console.log("NarrativeQA 데이터 조회 ", res.data.datas[0]); setLfsumQAData(res.data.datas[0]); setReason_path(JSON.parse(res.data.datas[0].reason_path)); })
        // alert("파일 업로드가 완료되었습니다.");
      .catch((error:any) => {console.error('에러',error.response);})
      // alert("파일 업로드 실패. " + error.response.data.error);
    },[search_doc_id])

  const [detailInfo, setDetailInfo] = useState<any>([]);
  const getSentenceDetail = async (did:string) => {
    
      setBackdrop(true)
      api.get('/getContextDetail',{params:{email:email, document_id:did}})
      .then((res:any) => {
  
        const datas = res.data.datas;
        // console.log('디테일 데이터', datas)
        
        if(datas && datas.length > 0){
          // 첫 번째 데이터 자동 선택
          setDetailInfo(datas[0]);
        }
        setBackdrop(false)
        })
      .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    }


  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getLFSumQAList = async () => {
    
    // email != 'hafrica@hufs.ac.kr'

    setBackdrop(true)
    api.get('/getLFSumQAList',{params:{email:email, worker:worker, page:page, order:order, job_yn:job_yn, gub_cd:gub_cd, idx:idx}})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setInstructionList(res.data);
        // setData(res.data.datas[0]);
        setLfsumQAList(res.data.datas);

        // console.log('리스트',res.data.datas)

        if((lfsumQAData && lfsumQAData.idx == -1) || (pagination && page != pagination.current_page)){
          setLfsumQAData(res.data.datas[0])
        }

        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        // console.log('api 리턴 데이터', res.data)
        setLfsumQAList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  useEffect(() => {
    if(props.rowDetail != undefined){
      if(props.rowDetail.instruction_data == 'Y'){
        // getPrcDetail(props.rowDetail.idx)
        // getSwInstructionDetail(props.rowDetail.idx)
        setPageType("update")
      }else{
        // getPrcDetail(props.rowDetail.idx)
        // setEvkn_detail_data(initailEvknData);
        setLfsumQAData(initailEvknData)
        setPageType("new")
      }
    }
    getLFSumQAList()
  }, [page, gub_cd, props.rowDetail]);

  // if(prc_data == undefined) {return <Paper sx={{width:"100%", overflow: "auto"}}><Box sx={{fontWeight:700, fontSize: "52px"}}>Loading ...</Box></Paper>}

  return (
    // (pageType == "new" ?
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>장문(LFSumQA) - 데이터 검수</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

        <Box display="flex">
          <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
            <Box sx={{width:"740px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
              <Box sx={{display:"flex", alignItems:"center"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>document_id</Box>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"240px"}}>
                        <TextField size="small" variant="filled" value={lfsumQAData.document_id} 
                          InputProps={{
                            readOnly: true,
                            style: { height:"30px", backgroundColor:"#fff", paddingBottom: "12px"},
                          }}
                        />
                      </Box>
                      {/* <Button sx={{ marginLeft: "100px"}} variant="contained" color="secondary" onClick={updateKeep}>
                        데이터 선정
                      </Button> */}
                    </Box>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>task_id</Box>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"240px"}}>
                        <TextField size="small" variant="filled" value={lfsumQAData.task_id} 
                          InputProps={{
                            readOnly: true,
                            style: { height:"30px", backgroundColor:"#fff", paddingBottom: "12px"},
                          }}
                        />
                      </Box>
                    </Box>
                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                    <Box><textarea value={detailInfo.document_title} readOnly={true} spellCheck="false" style={{width:"720px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                    <Box><textarea readOnly={true} value={detailInfo.context} wrap="off" spellCheck="false" style={{width:"720px",minHeight:"600px", lineHeight:"22px", fontSize:"15px", fontWeight:600,padding:"2px", whiteSpace: "pre", fontFamily: "Noto Sans KR"}}  /></Box>

                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box>

        {/* simpleQA */}
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
              <Box sx={{margin:"4px"}}>
                <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                  <Box>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>요약+규칙준수</Box>
                    <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                    <Box><textarea spellCheck="false" value={lfsumQAData.question_text || ""} onChange={(e) => {setLfsumQAData({ ...lfsumQAData, question_text: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"140px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box>
                <Box sx={{margin:"4px"}}>
                  <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                    <Box>
                      <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                      <Box><textarea spellCheck="false" value={lfsumQAData.gold_answer || ""} onChange={(e) => {setLfsumQAData({ ...lfsumQAData, gold_answer: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"140px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* <Box sx={{width:"420px"}}>
                <Box sx={{margin:"8px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gpt-4o)</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={lfsumQAData.answer_gpt || ""} style={{width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gemini)</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={lfsumQAData.answer_gemini || ""} style={{width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                  </Box>
                </Box>
              </Box> */}

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                      <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                        {/* <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box> */}
                        {/* <Box><textarea spellCheck="false" value={evkn_detail_data.instruction_sw || ""} onChange={(e) => {setEvkn_detail_data({ ...evkn_detail_data, instruction_sw: e.target.value });}} style={{width:"610px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box> */}
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(lfsumQAData.des === "None" ? "" : lfsumQAData.des) || ""} onChange={(e) => {setLfsumQAData({ ...lfsumQAData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                    {worker !== 'EVAL008' &&
                      <>
                        <Box sx={{width:"100%", marginTop: "8px"}}>
                          <Box display="flex" justifyContent="center">
                            <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                              onClick={() => {
                                updateColEvknData('Y');
                              }}
                            >
                              O (선정)
                            </Button>
                          </Box>
                        </Box>
                        <Box sx={{width:"100%", marginTop: "8px"}}>
                          <Box display="flex" justifyContent="center">
                            <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                              onClick={() => {
                                updateColEvknData('P');
                              }}
                            >
                              X
                            </Button>
                          </Box>
                        </Box>
                      </>
                    }
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>

        {/* 작업 리스트 */}
        <Box>
        {/* Task 단위 화면 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 4px 4px 4px", width:"320px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
              {/* <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>TASK</Box> 
              <Select id="gub_cd" value={gub_cd || "모두"} onChange={(e) => {setGub_cd(e.target.value );}} sx={{backgroundColor: "#fff",color:"green",width:"180px", height: "28px", marginLeft: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                <MenuItem dense value={"모두"}>모두</MenuItem>
                <MenuItem dense value={"1"}>SIMPLE</MenuItem>
                <MenuItem dense value={"3"}>HELLASWAG</MenuItem>
                <MenuItem dense value={"4"}>MMLU</MenuItem>
              </Select> */}
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{width:"36px", fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>난이도</Box></TableCell>
                    <TableCell align="center"><Box sx={{width:"100px", fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>유형</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {(lfsumQAList != undefined && lfsumQAList.length > 0) ? lfsumQAList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(lfsumQAData != undefined && row.idx === lfsumQAData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {setLfsumQAData(row); getSentenceDetail(row.document_id); setReason_path(JSON.parse(row.cot_rationale)); }}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    {/* <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.isp1_yn === "N" ? "2px solid red" : (row.isp1_yn === "0" ? "2px solid #bbb" : (row.isp1_yn === "Y" ? "2px solid #27cc2f" : "#000"))), color:"#000" }}>
                        {(row.isp1_yn === "Y" ? "적합" : (row.isp1_yn === "N" ? "부적합" : (row.isp1_yn === "0" ? "미작업":"-")))}
                      </Box>
                    </TableCell> */}
                    {/* <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.instruction_data === "Y" ? "2px solid #27cc2f" : "2px solid #bbb"), color:"#000" }}>
                        {(row.instruction_data === "Y" ? "작성" : "미작성")}
                      </Box>
                    </TableCell> */}
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"20px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.job_yn === "Y" ? "2px solid #27cc2f" : (row.job_yn === "P" ? "2px solid #7427cc" : "#000")), color:"#000" }}>
                        {/* {(row.job_yn === "Y" ? "완료" : (row.job_yn === "P" ? "X" : "미작업"))} */}
                        {row.difficulty}
                      </Box>
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"100px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px", color:"#000" }}>
                        {row.question_type}
                        {/* {(row.question_type === "1" ? "simple" : (row.question_type === "3" ? "hellaswag" : "mmlu"))} */}
                      </Box>
                    </TableCell>
                    {/* <TableCell align="left">{row.concept_en}</TableCell> */}
                    {/* <TableCell align="left">
                      <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                        {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                      </Box>
                    </TableCell> */}
                  </TableRow>
                  )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                  <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                    sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                    InputProps={{
                      style: {width: "60px", height:"23px", fontSize:"12px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          
          
        </Box>
      </Box>
            
        {/* : ""} */}
        
      </Box>

    </Paper>
  );
  
  
};

export default LFSumPage;
